var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-service flex-column"},[_c('Header'),_c('keep-alive',{attrs:{"exclude":"DataDetails,DataArea"}},[_c('router-view',{staticClass:"data-main flex-1"})],1),_c('wavesBg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }